import { useCallback } from 'react';
import { useFetchCompanyOptionsMutation } from '../../services/company';
import { ICompanyApiResponse, ICompanyOptions } from '../../components/CompanyBuilder/types/companyList';

const useCompanyOptions = () => {
  const [fetchCompanyOptions, { isLoading }] = useFetchCompanyOptionsMutation();

  const loadOptions = useCallback(
    async (input: string, type: string): Promise<ICompanyOptions[]> => {
      if (!input) return [];
      const res: ICompanyOptions[] = [];
      let data: ICompanyApiResponse[] = [];

      switch (type) {
        case 'Current Company By ID':
        case 'Past Company By ID':
        case 'Past or Current Company By ID':
        case 'Recent Company By ID':
          data = await fetchCompanyOptions({ prefix: input }).unwrap();
          break;
        default:
          return [];
      }

      const dups: string[] = [];
      data.forEach((item) => {
        const label: string = `${item.name}${item.other_names && item.other_names.length > 0 ? ` [${item.other_names.join(', ')}] ` : ''} (${item.domain})`;
        if (dups.indexOf(item.name.toLowerCase().trim()) < 0) {
          res.push({
            label: label,
            value: item.ref,
            name: item.name,
            ref: item.ref,
            key: item.ref,
            logo: item.logos && item.logos.length > 0 ? item.logos[0].ref : `li_${item.name.toLowerCase().trim().replaceAll(' ', '-')}`,
            domain: item.domain,
            ext_refs: item.ext_refs
          });
        }
        dups.push(item.name.toLowerCase().trim());
      });
      return res;
    },
    [fetchCompanyOptions]
  );

  return { loadOptions, isLoading };
};

export default useCompanyOptions;
